var CryptoJS = require('crypto-js');

// var nonce = 'ur8gsNXdRYzYjQ9B';
var nonce = window.PAGE_DATA.commonData.userInfo.nonce || '';
var pNonce = window.PAGE_DATA.commonData.userInfo.userId || '';

function getAes(str,timer){
	var key = CryptoJS.enc.Utf8.parse(nonce);
    var temp = nonce + "," +  str + "," + timer;
    var aes = CryptoJS.AES.encrypt(temp,key,{
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    var strAes = aes.toString();
    return strAes;
}
function getPhpAes(str,timer){
	var key = CryptoJS.enc.Utf8.parse(pNonce);
    var temp = pNonce + "," +  str + "," + timer;
    var aes = CryptoJS.AES.encrypt(temp,key,{
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    var strAes = aes.toString();
    return strAes;
}

module.exports = {
	getAes: getAes,
	getPhpAes: getPhpAes
}



// WEBPACK FOOTER //
// ./src/service/common/aes.js